<template>
    <div>
        <router-link to="/tools/featured/main/all" el="div" class="box">
            <p class="title">Main Navigation</p>
            <p class="subtitle">Manage featured positions for the main navigation</p>
        </router-link>
        
        <div class="columns">
            <!-- football -->
            <div class="column">
                <div class="box">
                    <h3 class="title is-3">Football</h3>
                    <router-link to="/tools/featured/main/football">
                        Featured
                    </router-link>
                    <br>
                    <router-link to="/tools/featured/sub/football">
                        Sub Menus
                    </router-link>
                    <br>
                    <router-link to="/tools/featured/apps/football">
                        Apps
                    </router-link>
                </div>
            </div>
            <!-- rugby -->
            <div class="column">
                <div class="box">
                    <h3 class="title is-3">Rugby</h3>
                    <router-link to="/tools/featured/main/rugby">
                        Featured
                    </router-link>
                    <br>
                    <router-link to="/tools/featured/sub/rugby">
                        Sub Menus
                    </router-link>
                    <br>
                    <router-link to="/tools/featured/apps/rugby">
                        Apps
                    </router-link>
                </div>
            </div>
            <!-- cricket -->
            <div class="column">
                <div class="box">
                    <h3 class="title is-3">Cricket</h3>
                    <router-link to="/tools/featured/main/cricket">
                        Featured
                    </router-link>
                    <br>
                    <router-link to="/tools/featured/sub/cricket">
                        Sub Menus
                    </router-link>
                    <br>
                    <router-link to="/tools/featured/apps/cricket">
                        Apps
                    </router-link>
                </div>
            </div>
        </div>
        <div class="columns">
            <!-- golf -->
            <div class="column">
                <div class="box">
                    <h3 class="title is-3">Golf</h3>
                    <router-link to="/tools/featured/main/golf">
                        Featured
                    </router-link>
                    <br>
                    <router-link to="/tools/featured/sub/golf">
                        Sub Menus
                    </router-link>
                    <br>
                    <router-link to="/tools/featured/apps/golf">
                        Apps
                    </router-link>
                </div>
            </div>
            <!-- motorsport -->
            <div class="column">
                <div class="box">
                    <h3 class="title is-3">Motorsport</h3>
                    <router-link to="/tools/featured/main/motorsport">
                        Featured
                    </router-link>
                    <br>
                    <router-link to="/tools/featured/sub/motorsport">
                        Sub Menus
                    </router-link>
                    <br>
                    <router-link to="/tools/featured/apps/motorsport">
                        Apps
                    </router-link>
                </div>
            </div>
            <!-- tennis -->
            <div class="column">
                <div class="box">
                    <h3 class="title is-3">Tennis</h3>
                    <router-link to="/tools/featured/main/tennis">
                        Featured
                    </router-link>
                    <br>
                    <router-link to="/tools/featured/sub/tennis">
                        Sub Menus
                    </router-link>
                    <br>
                    <router-link to="/tools/featured/apps/tennis">
                        Apps
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "Featured"
};
</script>

